import React from 'react';
import { styled, Button } from '@mui/material';

const StyledBackButton = styled(Button)(() => ({
  borderRadius: '15px',
  border: '2px solid var(--Brand-Cadet-Blue, #6599A5)',
  '& span': {
    background: 'linear-gradient(138deg, #6599A5 24.11%, #3B667E 83.2%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontFamily: 'Satoshi',
    fontSize: '17px',
    fontWeight: 700,
    lineHeight: '22px',
  },
  '&:hover': {
    border: '2px solid var(--Brand-Cadet-Blue, #6599A5)',
  },
}));

export default StyledBackButton;
